// Mutation hook - upload zalacznika kompozera (Base64). Zwraca tmpPath jako id.
// POST /api/ui/sales-crm/mailbox/upload-attachment
// Sprint 3 v4.1. tmpPath TTL 1h - pozniej trzeba przekazac jako ComposerAttachment.source=DISK_UPLOAD.

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type {
  IPostUploadAttachmentRequest,
  IPostUploadAttachmentResponse
} from 'api/types/composer';

const postUploadAttachment = (
  body: IPostUploadAttachmentRequest
): Promise<IPostUploadAttachmentResponse> =>
  axios.post('/sales-crm/mailbox/upload-attachment', body);

export const usePostUploadAttachment = (
  options?: UseMutationOptions<
    IPostUploadAttachmentResponse,
    IError,
    IPostUploadAttachmentRequest
  >
) =>
  useMutation<IPostUploadAttachmentResponse, IError, IPostUploadAttachmentRequest>(
    postUploadAttachment,
    options
  );
